import { Component, EventEmitter, Output, inject } from '@angular/core';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { Employee } from '../../../../_interfaces/employee.interface';
import { EmployeeService } from '../../../../_services/employee-service/employee.service';
import { AsyncPipe } from '@angular/common';
import { BoFormsModule } from '@bo/ng-forms';
import { AvatarComponent } from '../../avatar/avatar.component';
import { map, shareReplay } from 'rxjs';
import { LoaderComponent } from '../../loader/loader.component';

@Component({
  selector: 'app-employee-select-single',
  imports: [
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    AsyncPipe,
    BoFormsModule,
    AvatarComponent,
    LoaderComponent,
  ],
  templateUrl: './employee-select-single.component.html',
})
export class EmployeeSelectSingleComponent {
  protected employeeService = inject(EmployeeService);

  selectedEmployee: Employee | null = null;
  @Output() selectionChanged: EventEmitter<string | null> = new EventEmitter<string | null>();
  employeeOptions$ = this.employeeService.employeeAllOptionsUnmapped().pipe(
    map((employees) => employees.filter((employee) => !employee.is_card_holder)),
    shareReplay(1),
  );

  changeSelection(): void {
    this.selectionChanged.emit(this.selectedEmployee?.id);
  }

  // Custom search function for ng-select to search across card name and holder name
  customSearchFn = (term: string, item: Employee) => {
    const searchTerm = term.toLowerCase();

    // Search in holder's first name
    if (item.first_name?.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in holder's last name
    if (item.last_name?.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in full name (first + last)
    const fullName = `${item.first_name || ''} ${item.last_name || ''}`.toLowerCase().trim();
    return fullName.includes(searchTerm);
  };
}
